<div class="mr-1 mt-2 flex h-full flex-col overflow-hidden">
  <div class="h-0 min-h-full overflow-y-auto">
    <div class="flex flex-col gap-2">
      @for (thread of threads(); track thread.id) {
        <chat-thread
          [selected]="selectedThread()?.id === thread.id"
          [isOdd]="$odd"
          [unreadCount]="getUnreadCount(thread.id)"
          [thread]="thread"
          [ownUserId]="ownUserId()"
          [threadAssignees]="usersToAssignees()"
          (click)="onOpenThread(thread)"
        ></chat-thread>
      } @empty {
        <span class="text-gray-400 flex w-full items-center justify-center text-sm">
          {{ "chat.message.emptyList" | translate }}
        </span>
      }
    </div>
  </div>
</div>
